import ButtonVariants from "@core-components/button/ButtonVariants";
import SSCarousel from "@core-components/carousel/Carousel";
import Emoji, { type IEmojiProps } from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import type { AppRegion } from "@core-types/region.enum";
import { Group, Stack } from "@mantine/core";
import type { ReactNode } from "react";
import RegionSelectorBanner from "../../regionSelector/banner/RegionSelectorBanner";

export interface ICarouselProps {
  children: ReactNode;

  label?: ReactNode;
  emoji?: IEmojiProps["emoji"];

  title?: string;
  href?: string;
  initialSlide?: number;

  onRegionChange?: (region: AppRegion) => void;
}

const AccountCarousel: React.FC<ICarouselProps> = ({
  children,
  emoji,
  label,
  href,
  title,
  initialSlide = 0,
  onRegionChange,
}) => {
  return (
    <Stack className="w-full" gap={0}>
      {label && emoji && (
        <Group
          className="w-full px-3 xs:px-10 py-0 xs:py-5"
          justify="space-between"
          wrap="nowrap"
        >
          <SSHeadline>
            <Emoji.DYNAMIC emoji={emoji} size={26} /> {label}
          </SSHeadline>
          {href && <ButtonVariants.SeeMore href={href} title={title} />}
        </Group>
      )}
      <RegionSelectorBanner onRegionChange={onRegionChange} />
      <div className="max-w-full">
        <SSCarousel initialSlide={initialSlide}>{children}</SSCarousel>
      </div>
    </Stack>
  );
};

export default AccountCarousel;
